import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { triggerPdfDownload } from '../../redux/slices/pdfDownloadSlice';

export const PdfProvider = ({ children }) => {
  return <>{children}</>;
};

export const usePdf = () => {
  const dispatch = useDispatch();
  const activeDownloads = useSelector((state) => state.pdfDownloads?.activeDownloads || []);

  const downloadPdf = useCallback((projectId, Apiurl) => {
    return dispatch(triggerPdfDownload({ projectId, Apiurl }));
  }, [dispatch]);

  return {
    downloadPdf,
    activeDownloads,
  };
};

export default usePdf;